import { map, unionBy, reduce } from 'lodash';
import { Record } from 'immutable';

import { ITEM_FLAG } from 'commons-vehicle/constants/dataTypes.js';

const OptionsSelectionResolutionRecord = Record({
    id: '',
    isCancel: false,
    addedOptions: [],
    removedOptions: [],
    resolutionActionOptions: [],
    selected: false,
    isExteriorColour: false,
    availableExteriorColours: [],
    isInteriorColour: false,
    availableInteriorColours: [],
});

function getOptionsWithPricing(options, isLease, selectedFinanceTerm, taxesFactor, isRemoved) {
    const optionsPricing = map(options, (option) => {
        return option.getOptionDescriptionWithAmounts(isLease, selectedFinanceTerm, taxesFactor, isRemoved);
    });
    return optionsPricing;
}

class OptionsSelectionResolution extends OptionsSelectionResolutionRecord {
    getResolutionActionOptions(validationSelectedOptions) {
        const resolutionActionOptions = map(this.resolutionActionOptions, (resolutionActionOption) => {
            return {
                code: resolutionActionOption.code,
                supplier: resolutionActionOption.supplier,
                flag: resolutionActionOption.selected
                    ? ITEM_FLAG.SELECTED | ITEM_FLAG.USER_SELECTED
                    : ITEM_FLAG.NOT_SELECTED,
                amounts: {
                    retail: resolutionActionOption.retail,
                    residualizingAmount: resolutionActionOption.residualizingAmount,
                },
            };
        });
        return unionBy(resolutionActionOptions, validationSelectedOptions, 'code');
    }

    getResolution(triggerOption, isLease, selectedFinanceTerm, taxesFactor) {
        const { id, selected } = this;

        const addedOptions = getOptionsWithPricing(this.addedOptions, isLease, selectedFinanceTerm, taxesFactor, false);
        const removedOptions = getOptionsWithPricing(
            this.removedOptions,
            isLease,
            selectedFinanceTerm,
            taxesFactor,
            true
        );

        const addedTotals = reduce(
            addedOptions,
            (result, option) => {
                return {
                    retail: result.retail + option.retail,
                    taxes: result.taxes + option.taxes,
                    payment: result.payment + option.payment,
                    paymentTaxes: result.paymentTaxes + option.paymentTaxes,
                };
            },
            {
                retail: 0,
                taxes: 0,
                payment: 0,
                paymentTaxes: 0,
            }
        );

        const removedTotals = reduce(
            removedOptions,
            (result, option) => {
                return {
                    retail: result.retail + option.retail,
                    taxes: result.taxes + option.taxes,
                    payment: result.payment + option.payment,
                    paymentTaxes: result.paymentTaxes + option.paymentTaxes,
                };
            },
            {
                retail: 0,
                taxes: 0,
                payment: 0,
                paymentTaxes: 0,
            }
        );

        const pricingDifferenceTotal = {
            retail: addedTotals.retail + removedTotals.retail + triggerOption.retail,
            taxes: addedTotals.taxes + removedTotals.taxes + triggerOption.taxes,
            payment: addedTotals.payment + removedTotals.payment + triggerOption.payment,
            paymentTaxes: addedTotals.paymentTaxes + removedTotals.paymentTaxes + triggerOption.paymentTaxes,
        };

        return {
            id,
            addedOptions,
            removedOptions,
            pricingDifferenceTotal,
            selected,
        };
    }
}

export default OptionsSelectionResolution;
